/**
 * Represents different types of customer retention rates.
 */
export enum CustomerRetentionRateTypeModel {
	/**
	 * Represents an annual retention rate.
	 */
	Annual = 1,
	/**
	 * Represents a monthly retention rate.
	 */
	Monthly = 2
}
